/* Shalom Bonic: barra fija de compra en celular (fichas de producto) */
(function(){
  if(window.__sbConv) return; window.__sbConv=1;
  if(location.pathname.indexOf('/products/')!==0) return;
  try{ if(new URLSearchParams(location.search).get('drawer')==='1') return; }catch(e){}
  var SEL='form[action*="/cart/add"] .gp-button-atc, form[action*="/cart/add"] button[name="add"]';
  var bar=null, btn=null, io=null;

  function visible(el){
    if(!el) return false;
    var r=el.getBoundingClientRect(), s=window.getComputedStyle(el);
    return s.display!=='none' && s.visibility!=='hidden' && r.width>0 && r.height>0;
  }
  function mainBtn(){
    var l=document.querySelectorAll(SEL);
    for(var i=0;i<l.length;i++){ if(!l[i].closest('#sb-sticky') && visible(l[i])) return l[i]; }
    return null;
  }
  function nombre(){
    var d=window.__sbPV; if(d&&d.t) return d.t;
    var h=document.querySelector('h1'); return h?h.textContent.trim():document.title;
  }
  function css(){
    var st=document.createElement('style');
    st.textContent=
      '#sb-sticky{display:none}'+
      '@media (max-width:749px){'+
      '#sb-sticky{position:fixed;left:0;right:0;bottom:0;z-index:900;display:flex;align-items:center;gap:12px;padding:8px 14px calc(8px + env(safe-area-inset-bottom));background:#fff;border-top:1px solid #E8C9D5;box-shadow:0 -4px 14px rgba(0,0,0,.10);transform:translateY(110%);transition:transform .2s ease;pointer-events:none}'+
      '#sb-sticky.on{transform:translateY(0);pointer-events:auto}'+
      '#sb-sticky .sb-s-i{flex:1;min-width:0}'+
      '#sb-sticky .sb-s-n{display:block;font-size:14px;font-weight:700;line-height:1.25;color:#1E1D1B;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}'+
      '#sb-sticky button{flex:none;min-height:42px;padding:0 20px;border:0;border-radius:99px;background:#8C1D40;color:#fff;font:inherit;font-size:14px;font-weight:700;cursor:pointer;white-space:nowrap}'+
      'html.sb-stk .sb-wa-floating{bottom:calc(72px + env(safe-area-inset-bottom)) !important}'+
      'html.sb-stk [data-sb-up]{bottom:calc(136px + env(safe-area-inset-bottom)) !important;top:auto !important}'+
      'html.sb-stk #sb-image-popup-scope .sb-minimized{bottom:calc(72px + env(safe-area-inset-bottom)) !important}'+
      '}';
    document.head.appendChild(st);
  }
  /* Boton "subir": se busca cualquier elemento fijo pequeno en la esquina derecha inferior y se sube sobre la barra */
  var subirHecho=false;
  function subir(){
    if(subirHecho) return;
    var W=window.innerWidth, H=window.innerHeight, els=document.body.querySelectorAll('*');
    for(var i=0;i<els.length;i++){
      var e=els[i];
      if(e.offsetParent!==null) continue;
      if(e.closest('#sb-sticky,#sb-tabs,.sb-wa-floating,#sb-image-popup-scope')) continue;
      var r=e.getBoundingClientRect();
      if(r.width<28||r.width>90||r.height<28||r.height>90) continue;
      if(r.right<W-70||r.bottom<H-170||r.bottom>H+40) continue;
      if(getComputedStyle(e).position!=='fixed') continue;
      e.setAttribute('data-sb-up','1'); subirHecho=true;
    }
  }
  function tocar(){
    var b=mainBtn(); if(!b) return;
    var rx=document.getElementById('sb-rx')||document.getElementById('rx-confirmation-box');
    if(rx||b.disabled){ (rx||b).scrollIntoView({behavior:'smooth',block:'center'}); return; }
    b.click();
  }
  /* ---- Bloque premium unico: reemplaza textos repetidos de envio/garantia ---- */
  function nodos(re){
    var w=document.createTreeWalker(document.body,NodeFilter.SHOW_TEXT,null), n, l=[];
    while((n=w.nextNode())){
      var p=n.parentElement; if(!p) continue;
      var tg=p.tagName; if(tg==='SCRIPT'||tg==='STYLE'||tg==='NOSCRIPT') continue;
      if(p.closest('#sb-conf,#sb-sticky')) continue;
      if(re.test(n.nodeValue)) l.push(n);
    }
    return l;
  }
  function largo(el){ return (el.textContent||'').replace(/\s+/g,' ').trim().length; }
  function ocultar(el){ if(el&&!el.getAttribute('data-sb-off')){ el.setAttribute('data-sb-off','1'); el.style.setProperty('display','none','important'); } }
  function ancestroComun(a,b){
    var x=a; while(x){ if(x.contains(b)) return x; x=x.parentElement; } return null;
  }
  function limpiar(){
    /* "Entrega estimada entre ..." (fecha que no corresponde a 1 a 4 dias) */
    nodos(/Entrega estimada/i).forEach(function(n){
      var el=n.parentElement;
      while(el.parentElement && el.parentElement!==document.body && largo(el.parentElement)<80) el=el.parentElement;
      ocultar(el);
    });
    /* Franja de 4 iconos: se busca el contenedor mas pequeno que tenga los 4 textos */
    var res=[/de calidad garantizada/i,/Env[ií]os express/i,/Tiempo de entrega/i,/Seguimiento entre/i];
    var cands=res.map(function(re){ return nodos(re).map(function(n){ return n.parentElement; }); });
    for(var i=0;i<cands.length;i++){ if(!cands[i].length) return; }
    var best=null;
    cands[0].forEach(function(a){
      var lca=a;
      for(var k=1;k<cands.length&&lca;k++){
        var m=null, ml=1e9;
        cands[k].forEach(function(b){ var x=ancestroComun(lca,b); if(x){ var L=largo(x); if(L<ml){ ml=L; m=x; } } });
        lca=m;
      }
      if(lca&&lca!==document.body){ var L2=largo(lca); if(!best||L2<best.L) best={e:lca,L:L2}; }
    });
    if(best&&best.L<320){
      var blk=document.getElementById('sb-conf');
      if(blk && !blk.getAttribute('data-sb-mov')){ best.e.insertAdjacentElement('beforebegin',blk); blk.setAttribute('data-sb-mov','1'); }
      ocultar(best.e);
    }
  }
  function svg(p){ return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="#8C1D40" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'+p+'</svg>'; }
  function confianza(b){
    if(document.getElementById('sb-conf')) return;
    var st=document.createElement('style');
    st.textContent=
      '#sb-conf{margin:18px 0;opacity:0;transform:translateY(8px);animation:sbIn .6s cubic-bezier(.2,.7,.2,1) .1s forwards}'+
      '@keyframes sbIn{to{opacity:1;transform:none}}'+
      '@keyframes sbSh{0%{background-position:200% 0}100%{background-position:-200% 0}}'+
      '#sb-conf .g{padding:1px;border-radius:18px;background:linear-gradient(135deg,#8C1D40 0%,#EBC9D6 48%,#C2185B 100%);box-shadow:0 10px 24px -14px rgba(140,29,64,.45)}'+
      '#sb-conf .in{display:grid;grid-template-columns:repeat(3,1fr);border-radius:17px;background:linear-gradient(180deg,#fff,#FFF8FA);overflow:hidden}'+
      '#sb-conf .i{display:flex;flex-direction:column;align-items:center;gap:7px;padding:14px 4px 13px;text-align:center;text-decoration:none;color:#1E1D1B;position:relative;opacity:0;animation:sbIn .5s ease forwards;transition:background .2s}'+
      '#sb-conf .i:nth-child(1){animation-delay:.25s}#sb-conf .i:nth-child(2){animation-delay:.35s}#sb-conf .i:nth-child(3){animation-delay:.45s}'+
      '#sb-conf .i+.i:before{content:"";position:absolute;left:0;top:20%;bottom:20%;width:1px;background:#EBD3DC}'+
      '#sb-conf .ic{width:38px;height:38px;border-radius:50%;display:flex;align-items:center;justify-content:center;background:radial-gradient(circle at 30% 25%,#FFF1F6,#F7D9E5);transition:transform .25s ease}'+
      '#sb-conf .i:hover .ic{transform:translateY(-2px) scale(1.07)}'+
      '#sb-conf .i b{font-size:13px;font-weight:700;line-height:1.15;letter-spacing:.01em}'+
      '#sb-conf .i span{font-size:11px;color:#7A6870;line-height:1.2;margin-top:-4px}'+
      '#sb-conf a.i:hover{background:#FBEFF3}'+
      '#sb-conf .p{margin-top:10px;text-align:center}'+
      '#sb-conf .bar{height:4px;border-radius:99px;background:#F1DCE5;overflow:hidden;margin:0 auto 7px;max-width:100%;display:none}'+
      '#sb-conf .bar i{display:block;height:100%;width:0;border-radius:99px;background:linear-gradient(90deg,#8C1D40,#E0457B,#8C1D40);background-size:200% 100%;animation:sbSh 3s linear infinite;transition:width .8s ease}'+
      '#sb-conf .c{margin:0;font-size:12px;color:#6B5A61;line-height:1.4}'+
      '#sb-conf .c b{color:#8C1D40;font-weight:700}'+
      '@media (prefers-reduced-motion:reduce){#sb-conf,#sb-conf .i{animation:none;opacity:1;transform:none}#sb-conf .bar i{animation:none}}';
    document.head.appendChild(st);
    var wa='https://wa.me/573027149636?text='+encodeURIComponent('Hola, tengo una duda con este producto: '+nombre());
    var d=document.createElement('div'); d.id='sb-conf';
    d.innerHTML=
      '<div class="g"><div class="in">'+
        '<div class="i"><span class="ic">'+svg('<path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7.5" cy="17.5" r="1.8"/><circle cx="17.5" cy="17.5" r="1.8"/>')+'</span><b>1 a 4 días</b><span>Envío a toda Colombia</span></div>'+
        '<div class="i"><span class="ic">'+svg('<path d="M12 3l7 3v5c0 4.5-3 8-7 10-4-2-7-5.5-7-10V6z"/><path d="M9 12l2 2 4-4"/>')+'</span><b>Garantía</b><span>de fabricación</span></div>'+
        '<a class="i" href="'+wa+'" target="_blank" rel="noopener noreferrer"><span class="ic">'+svg('<path d="M21 12a8 8 0 0 1-11.6 7.1L4 20l1-4.3A8 8 0 1 1 21 12z"/><path d="M8.5 12h.01M12 12h.01M15.5 12h.01"/>')+'</span><b>Asesoría</b><span>por WhatsApp</span></a>'+
      '</div></div>'+
      '<div class="p"><div class="bar"><i></i></div><p class="c">Envío $19.000 · <b>gratis desde $360.000</b></p></div>';
    var f=b.closest('form')||b;
    f.insertAdjacentElement('afterend',d);
    /* Dinamico: con productos en el carrito, barra de progreso hacia el envio gratis */
    try{
      fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){
        if(!c||!c.item_count) return;
        var total=Math.round(c.total_price/100), falta=360000-total;
        var fmt=function(n){return '$'+Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g,'.');};
        var bar=d.querySelector('.bar'), fill=bar.firstChild, p=d.querySelector('.c');
        bar.style.display='block';
        setTimeout(function(){ fill.style.width=Math.max(6,Math.min(100,total/3600))+'%'; },60);
        p.innerHTML = falta>0 ? 'Te faltan <b>'+fmt(falta)+'</b> para el envío gratis' : '<b>Tu pedido ya tiene envío gratis</b>';
      }).catch(function(){});
    }catch(e){}
  }
  function construir(b){
    btn=b; css(); confianza(b);
    limpiar(); setTimeout(limpiar,1000); setTimeout(limpiar,2500); setTimeout(limpiar,5000); setTimeout(limpiar,9000);
    bar=document.createElement('div'); bar.id='sb-sticky';
    var i=document.createElement('div'); i.className='sb-s-i';
    var n=document.createElement('span'); n.className='sb-s-n'; n.textContent=nombre();
    i.appendChild(n);
    var k=document.createElement('button'); k.type='button'; k.textContent='Agregar al carrito';
    k.addEventListener('click',tocar);
    bar.appendChild(i); bar.appendChild(k);
    document.body.appendChild(bar);
    var ultimo=0;
    window.addEventListener('scroll',function(){
      if(subirHecho||!bar.classList.contains('on')) return;
      var t=Date.now(); if(t-ultimo<500) return; ultimo=t; subir();
    },{passive:true});
    function mostrar(v){
      bar.classList.toggle('on',v);
      document.documentElement.classList.toggle('sb-stk',v);
      if(v){ subir(); setTimeout(subir,700); }
    }
    if('IntersectionObserver' in window){
      io=new IntersectionObserver(function(es){ mostrar(!es[0].isIntersecting); },{threshold:0.01});
      io.observe(btn);
    }
  }
  function iniciar(){
    var intentos=0;
    var t=setInterval(function(){
      intentos++;
      var b=mainBtn();
      if(b){ clearInterval(t); construir(b); }
      else if(intentos>30) clearInterval(t);
    },400);
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',iniciar); else iniciar();
})();